module.exports = __webpack_public_path__ + "media/images/icons/flags/PY-f7c7f35d4a84a89767f57f737f313389.svg";